<div #host class="app-turnstile-host" aria-live="polite"></div>
<p *ngIf="loadErrCode && showInlineError && !isProduction" class="app-turnstile-error" role="alert">
  {{ loadErrCode.msg }}
</p>
